import { Audience } from 'types/schemaTypes';
import { AudienceStatus, UNSUPPORTED_STATUSES_FOR_DEAL } from 'modules/audiences/constants';

export function canCreateDealWithAudience({ status }: Pick<Audience, 'status'>): boolean {
  return !UNSUPPORTED_STATUSES_FOR_DEAL.includes(status as AudienceStatus);
}

export const notSupportDealMesssage = 'Deals cannot be created using an expired or failed audience.';
